import * as React from 'react';
import { observer } from 'mobx-react';
import { StoreContext } from '../../utils';
import { Store } from '../../store/Store';

type Props = {};

@observer
export class PortalSubheader extends React.Component<Props> {
  static contextType = StoreContext;
  declare context: Store;

  render() {
    if (!this.context.portalStore.subheaderTitle) {
      return null;
    }

    return (
      <div className="subheader py-2 py-lg-4 subheader-transparent" id="kt_subheader">
        <div className="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
          {/*begin::Details*/}
          <div className="d-flex align-items-center flex-wrap mr-2">
            {/*begin::Title*/}
            <h5 className="text-dark font-weight-bold mt-2 mb-2 mr-5">{this.context.portalStore.subheaderTitle}</h5>
            {/*end::Title*/}
            {/*begin::Separator*/}
            <div className="subheader-separator subheader-separator-ver mt-2 mb-2 mr-5 bg-gray-200" />
            {/*end::Separator*/}
            {/*begin::Search Form*/}
            {/*end::Search Form*/}
          </div>
          {/*end::Details*/}
          {/*begin::Toolbar*/}
          {/*end::Toolbar*/}
        </div>
      </div>
    );
  }
}
